import { ContactMethod } from '@shared/models/contact';

import { Company } from './company-applicant.contract';
import { TrustApplicant } from './trust-applicant.contract';
import { EntityCollection } from '../../core/models/schema-property-definition';
import { IndividualApplicant } from '@features/opportunities/modules/applicant/services/individual-applicant.contract';

export namespace Applicant {
  export enum Type {
    Individual = 'Individual',
    Company = 'Company',
    Trust = 'Trust',
    SmsfTrust = 'SmsfTrust',
    BareTrust = 'BareTrust'
  }

  export namespace Type {
    export function getSchemaName(type: Type): string {
      switch (type) {
        case Type.Individual:
          return 'individuals';
        case Type.Company:
          return 'companies';
        case Type.Trust:
        case Type.SmsfTrust:
        case Type.BareTrust:
          return 'trusts';
      }
    }
  }

  export namespace Role {
    export enum MpmOnly {
      Borrower = 'Borrower',
      Guarantor = 'Guarantor'
    }

    export enum General {
      Borrower = 'Borrower',
      Guarantor = 'Guarantor',
      Guarantor_Security_Only = 'Guarantor (security only)',
    }

    export enum InsuranceOnly {
      Insured = 'Insured'
    }

    export enum SmsfOnly {
      Borrower = 'Borrower',
      Guarantor = 'Guarantor',
      Guarantor_Security_Only = 'Guarantor (security only)',
      Mortgagor = 'Mortgagor',
      TrusteeForPropertyTrust = 'Trustee for property trust',
      TrusteeForSMSF = 'Trustee for SMSF'
    }
  }

  export interface Summary {
    id: string;
    entityId: string;
    displayName: string;
    applicantType: Applicant.Type;
    role: string;
    contactNumber: string;
    contactMethod?: ContactMethod | null;
    email: string | null;
    description: string;
  }

  export interface SharePercentage {
    id: string;
    share: number | null;
  }

  export namespace Collection {
    export interface SchemaContract {
      individuals: EntityCollection.SchemaContract<IndividualApplicant.SchemaContract>;
      companies: EntityCollection.SchemaContract<Company.SchemaContract>;
      trusts: EntityCollection.SchemaContract<TrustApplicant.SchemaContract>;
    }

    export interface Model {
      individuals: IndividualApplicant.Model[];
      companies: Company.Model[];
      trusts: TrustApplicant.Model[];
    }

    export function toSummary(c: SchemaContract): Applicant.Summary[] {
      return EntityCollection.toModel(
        c.individuals,
        IndividualApplicant.SchemaContract.toApplicantSummary
      )
        .concat(
          EntityCollection.toModel(c.companies, Company.toApplicantSummary)
        )
        .concat(
          EntityCollection.toModel(c.trusts, TrustApplicant.toApplicantSummary)
        );
    }

    export function toModel(c: SchemaContract): Model {
      return {
        individuals: EntityCollection.toModel(
          c.individuals,
          IndividualApplicant.toModel
        ),
        companies: EntityCollection.toModel(c.companies, Company.toModel),
        trusts: EntityCollection.toModel(c.trusts, TrustApplicant.toModel)
      };
    }
  }
}
